import { render } from "./Incidences.vue?vue&type=template&id=5e57118e"
import script from "./Incidences.vue?vue&type=script&lang=js"
export * from "./Incidences.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__